// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3uSsb","label":"Completed_label__1ni1W"};